const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";
const USER_LOGOUT = "USER_LOGOUT";

const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
const USER_REGISTER_FAILURE = "USER_REGISTER_FAILURE";

const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
const USER_DETAILS_FAILURE = "USER_DETAILS_FAILURE";
const USER_DETAILS_RESET = "USER_DETAILS_RESET";

const USER_UPDATE_PROFILE_REQUEST = "USER_UPDATE_PROFILE_REQUEST";
const USER_UPDATE_PROFILE_SUCCESS = "USER_UPDATE_PROFILE_SUCCESS";
const USER_UPDATE_PROFILE_FAILURE = "USER_UPDATE_PROFILE_FAILURE";
const USER_UPDATE_PROFILE_RESET = "USER_UPDATE_PROFILE_RESET";

const USERS_LIST_REQUEST = "USERS_LIST_REQUEST";
const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS";
const USERS_LIST_FAILURE = "USERS_LIST_FAILURE";
const USERS_LIST_RESET = "USERS_LIST_RESET";

const USER_DELETE_REQUEST = "USER_DELETE_REQUEST";
const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
const USER_DELETE_FAILURE = "USER_DELETE_FAILURE";
const USER_DELETE_RESET = "USER_DELETE_RESET";

const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
const USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE";
const USER_UPDATE_RESET = "USER_UPDATE_RESET";

export {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAILURE,
  USER_DETAILS_RESET,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_UPDATE_PROFILE_FAILURE,
  USER_UPDATE_PROFILE_RESET,
  USERS_LIST_REQUEST,
  USERS_LIST_SUCCESS,
  USERS_LIST_FAILURE,
  USERS_LIST_RESET,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAILURE,
  USER_DELETE_RESET,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE,
  USER_UPDATE_RESET,
};
